export default {
  title: 'Atualizar hora de entrega',
  labels: {
    dropoff_time: 'Hora de entrega',
    confirmed: 'Hora confirmada:',
    new_time: 'Nova hora:',
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    success: 'Hora de entrega atualizada com sucesso',
    failed_to_save: 'Falha ao guardar as alterações',
  },
  alerts: {
    dropoff_time_info: 'A hora atual e a nova hora estão no fuso horário {{restaurantName}} {{timezone}}',
  },
};
